/**
 * Created by wwei on 2017-06-29.
 */
import React, { Component } from "react";
import { translate } from "react-i18next";
import LanguageSelect from "./LanguageSelect.js";
import Settings from "../Settings.js";

class Footer extends Component {
  render() {
    const { t } = this.props;
    const year = new Date().getFullYear();
    return (
      <div className="div_footer" style={{ left: this.props.left }}>
        <div className="hr-dashed" />
        <div className="wrapper">
          <div className="left">
            {t("FOOTER.COPYRIGHT_CONTENT", { year: year })}
            &nbsp;|&nbsp;
          </div>
          <div className="left">
            <a
              href={Settings.LICENSE_AGREEMENT_URL}
              style={{ color: "#3c99d1" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("FOOTER.TERMS_OF_SERVICE")}
            </a>
            &nbsp;|&nbsp;
          </div>
          <div className="left">
            <a
              href={Settings.PRIVACY_URL}
              style={{ color: "#3c99d1" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("FOOTER.PRIVACY_POLICY")}
            </a>
          </div>
          {Settings.LOCALIZATION && (
            <div className="right" style={{ marginRight: 30 }}>
              <LanguageSelect />
            </div>
          )}
          <div className="clear" />
        </div>
      </div>
    );
  }
}

export default translate()(Footer);



// WEBPACK FOOTER //
// ./src/common/struct/Footer.js